module.exports = __webpack_public_path__ + "img/16.1ae0b23c.jpg";